export const LIVESTREAM_PINNED_COMMENT_MESSAGE_TYPE = "fanrank:pinnedComment";

export const LIVESTREAM_PINNED_COMMENT_SYNC_REQUEST_MESSAGE_TYPE =
  "fanrank:pinnedCommentSyncRequest";

export type LivestreamPinnedComment = {
  messageId: string;
  displayName: string;
  text: string;
};

export function parseLivestreamPinnedComment({
  payload,
}: {
  payload: Record<string, boolean | number | string | Date>;
}): LivestreamPinnedComment | null {
  const messageId = payload.messageId;
  if (typeof messageId !== "string" || !messageId) return null;

  const displayName = payload.displayName;
  const text = payload.text;
  if (typeof displayName !== "string" || typeof text !== "string") return null;

  return {
    messageId,
    displayName,
    text: text.trim() || "",
  };
}

export function parseLivestreamPinnedCommentClear({
  payload,
}: {
  payload: Record<string, boolean | number | string | Date>;
}): boolean {
  return payload.cleared === true;
}

export function buildLivestreamPinnedCommentPayload({
  comment,
}: {
  comment: LivestreamPinnedComment;
}): Record<string, string> {
  return {
    messageId: comment.messageId,
    displayName: comment.displayName,
    text: comment.text,
  };
}

export function buildLivestreamPinnedCommentClearPayload(): Record<string, boolean> {
  return { cleared: true };
}

export function parseLivestreamPinnedCommentSyncRequest({
  payload,
}: {
  payload: Record<string, boolean | number | string | Date>;
}): string | null {
  const participantId = payload.participantId;
  if (typeof participantId !== "string" || !participantId) return null;
  return participantId;
}

export function buildLivestreamPinnedCommentSyncRequestPayload({
  participantId,
}: {
  participantId: string;
}): Record<string, string> {
  return { participantId };
}
